<template>
  <BittsContainer
    no-padding
    class="c-list-container"
    :data-show-hover="showHover"
  >
    <slot name="header" />
    <template v-for="(item, index) in list" :key="getKey?.(item) ?? index">
      <div
        class="item"
        :class="{
          'item--first': index === 0,
          'item--last': index + 1 === list.length,
        }"
        role="presentation"
        @click="() => onClickItem?.(item)"
      >
        <slot :item="item" :index="index" />
      </div>
      <slot
        name="extra"
        :item="item"
        :is-last-item="index + 1 === list.length"
      />
      <BittsDivider
        v-if="index + 1 < list.length || hasDivider(item)"
        class="my-0"
      />
    </template>
  </BittsContainer>
</template>

<script setup lang="ts" generic="T">
import { BittsContainer, BittsDivider } from '@crossbeam/bitts';

const {
  list,
  onClickItem,
  getKey,
  hasDivider = () => true,
  showHover = false,
} = defineProps<{
  list: T[];
  onClickItem?: (item: T) => void;
  getKey?: (item: T) => string | number;
  hasDivider?: (item: T) => boolean;
  showHover?: boolean;
}>();
</script>

<style scoped lang="pcss">
@reference "../css/theme.css";
.c-list-container {
  @apply flex flex-col;
}
.item--first {
  @apply rounded-t-16;
}
.item--last {
  @apply rounded-b-16;
}

.c-list-container[data-show-hover='true'] .item:hover {
  @apply bg-neutral-background-weak;
}
</style>
